import React, { ReactNode } from "react";

type Props = {
  pageTitle: string;
  children: ReactNode;
  primaryAction?: ReactNode;
};
export default function PageLayout({
  pageTitle,
  children,
  primaryAction,
}: Props) {
  const renderPrimaryActions = () => {
    if (!primaryAction) {
      return null;
    }
    return (
      <div className="flex flex-wrap gap-3 sm:justify-end w-full sm:w-auto sm:ml-auto">
        {primaryAction}
      </div>
    );
  };

  return (
    <div className="bg-background min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="flex flex-col sm:flex-row w-full items-start sm:items-center gap-4 animate-fade-in">
        <h1 className="text-[26px] sm:text-[30px] lg:text-[34px] font-dmSans font-bold capitalize bg-gradient-heading bg-clip-text text-transparent pl-12 smallLaptop:pl-12 lg:pl-0">
          {pageTitle}
        </h1>
        {renderPrimaryActions()}
      </div>

      <div className="my-4 bg-inherit animate-fade-in-slow">{children}</div>
    </div>
  );
}
